import pro1 from "../assets/todo-list.png";
import pro2 from "../assets/movieapp.png";
import pro3 from "../assets/ecommerce-intern-assign.png";
import pro4 from "../assets/Newsletter.png";
import portf from "../assets/portfolio.png";
const ProjectCardData = [
  {
    imgsrc: portf,
    title: "Portfolio",
    text: "Personal portfolio website created to showcase one's personal skills in React, CSS and responsive web design",
    view: "https://chrisgurung.com.np/",
    source: "https://github.com/Chris-Grg/portfolio-gen1",
    code: "react",
  },
  {
    imgsrc: pro1,
    title: "To-Do-List",
    text: "Create, update, and delete notes with ease using our intuitive To-Do List application. Stay organized and never forget a task again. With a clean and user-friendly interface, managing your daily tasks has never been easier.",
    view: "https://todolist-sol.vercel.app/",
    source: "https://github.com/Chris-Grg/todolist-sol",
    code: "react",
  },
  {
    imgsrc: pro2,
    title: "Movie App",
    text: "Discover and explore your favorite movies with our Movie App. Powered by the OMDB API, you can access a vast collection of movie. Save your favorite movies to your personal list",
    view: "https://simple-movie-list-nu.vercel.app/",
    source: "https://github.com/Chris-Grg/simple-movie-list",
    code: "react",
  },
  {
    imgsrc: pro3,
    title: "ecommerce-website",
    text: "Look through variety of products available in the website. Api provided through the fakestoreapi, you can search for specific products and click on the product to view additional details about it.",
    view: "https://frontend-assignment-onlinestore.vercel.app/",
    source: "https://github.com/Chris-Grg/frontend-assignment",
    code: "react",
  },
  {
    imgsrc: pro4,
    title: "Newsletter",
    text: "This is an expressjs app which uses mailchimp api to sign up users to a mailing list",
    view: "https://github.com/Chris-Grg/Newsletter-signup",
    source: "https://github.com/Chris-Grg/Newsletter-signup",
    code: "js",
  },
];
export default ProjectCardData;
